import http from './_http'
import http_v2 from './_http_v2'

const auth = {
  //restful api 로 변경작업 진행중

  //login
  preflight: (m) => { return http_v2.post(`console/auth/preflight`, m); },
  login : (m) => { return http_v2.post(`console/auth/login`, m);},
  checkPasswordCycle : () => { return http_v2.get(`console/auth/password/cycle`); },
  refresh: () => { return http_v2.get(`console/auth/refresh/` + new Date().getTime()); },
  setAuth: (token) => { 
    http.defaults.headers.common['Authorization'] = 'Bearer ' + token; 
    http_v2.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  },
  unsetAuth: () => { 
    delete http.defaults.headers.common['Authorization']; 
    delete http_v2.defaults.headers.common['Authorization'];
  },

  //profile
  // get: (m) => { return http_v2.get(`console/auth/profile`, m); },
  // update: (m) => { return http_v2.put(`console/auth/profile`, m); },

  //otp
  otpGen: (m) => { return http_v2.get(`console/auth/otp/gen`, m); },
  otpVerify: (m) => { return http_v2.post(`console/auth/otp/verify`, m); },
  otpRegister: (m) => { return http_v2.put(`console/auth/otp/register`, m); },
  otpUnregister: (m) => { return http_v2.put(`console/auth/otp/unregister`, m); },

  //password
  ResetPassword: (m) => { return http_v2.post(`console/auth/password/resetmail`, m); }, //password resetMail
  tokenVerify: (m) => { return http_v2.post(`console/auth/password/verify`, m); }, //
  tokenReset: (m) => { return http_v2.put(`console/auth/password/change`, m); }, //password change
  passwordChange: (m) => { return http_v2.put(`console/auth/password`, m); },

  //해당 api 안쓰는것으로 추정
  mailCode: (m) => { return http_v2.post(`console/auth/email/code`, m); },

  register: (m) => { return http_v2.post(`console/auth/register`, m); },

  groupUpdate: (m) => { return http_v2.put(`console/auth/group`, m); },
  groupService: (m) => { return http_v2.put(`console/auth/group/service`, m); },



  ///////////////////

  // token: () => http.get('auth/token'), // not used
  // login: (m) => { return http.post('auth/user/login', m); },
  profile: (m) => { return http.post('auth/user/profile', m); },
  get: (m) => { return http.post('auth/user/profile/get', m); },
  // preflight: (m) => { return http.post('auth/user/preflight', m); },
  update: (m) => { return http.post('auth/user/profile/update', m); },
  // pwd_update: (m) => { return http.post('auth/user/password/update', m); },
  // refresh: () => { return http_v2.get('console/auth/refresh/' + new Date().getTime()); },
  // refresh: () => { return http.get('auth/user/refresh/' + new Date().getTime()); },
  // regist : (m) => { return http.post('auth/user/regist/',m); },
  // otpGen : (m) => { return http.post('auth/user/otp/gen',m); },
  // checkPasswordCycle: (m) => { return http.post('auth/user/cycle/password', m); },
  // otpVerify : (m) => { return http.post('auth/user/otp/verify', m); },
  // otpRegister : (m) => { return http.post('auth/user/otp/register', m); },
  // otpUnregister : (m) => { return http.post('auth/user/otp/unregister', m); },
  otpUpdate : (m) => { return http.post('auth/user/otp/update',m); },
  // ResetPassword : (m) => { return http.post('auth/user/reset/password', m); }, 3


  // tokenReset : (m) => { return http.post('auth/user/reset/token', m); }, 1
  // tokenVerify : (m) => { return http.post('auth/user/reset/verify', m); }, 2

  license : (m) => { return http.post('auth/user/license/once', m); },
  licenseAgentInstall : (m) => { return http.post('auth/user/license/agent', m); }

}

export default auth
